import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  IconWarning,
  dlsBrightBlue,
} from '@americanexpress/dls-react';

const InEligibleErrorPage = () => {
  const {
    messages: {
      links: {
        home,
      },
    },
  } = useIntl();
  return (
    <div className="row dls-white-bg flex flex-justify-center">
      <div className="col-lg-6 col-md-8 col-sm-10">
        <div className="flex flex-justify-center flex-align-items-center">
          <IconWarning className="pad-4-t" theme={dlsBrightBlue} title="IconWarning icon" size="xl" />
        </div>
        <div className="flex flex-justify-center flex-align-items-center text-align-center heading-4 pad-3-tb">
          <FormattedMessage id="ineligible.error.title" />
        </div>
        <div className="body-1 flex flex-justify-center flex-align-items-center text-align-center margin-3-lr-lg-up">
          <FormattedMessage id="ineligible.error.message" />
        </div>
        <div className="flex flex-justify-center flex-align-items-center pad-4-tb">
          <a
            type="button"
            aria-label="ReturnHome"
            className="btn btn-secondary"
            id="returnToHomePageErrorButton"
            href={home}
          >
            <FormattedMessage id="ineligible.error.button" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default InEligibleErrorPage;
